import React from "react";
import type {FunctionComponent, VoidFunctionComponent} from "react";
import {useIfSongsPageRequestCompleteLogic} from "./IfSongsPageRequestComplete.logic";

export interface IIfSongsPageRequestCompleteProps {
  fallback?: VoidFunctionComponent;
}

export const IfSongsPageRequestComplete: FunctionComponent<IIfSongsPageRequestCompleteProps> = ({children, fallback: FallbackComponent}) => {
  const {isRequestComplete} = useIfSongsPageRequestCompleteLogic();

  if (isRequestComplete) {
    return <>{children}</>;
  }

  // not ready
  if (!FallbackComponent) {
    // no fall back component
    return null;
  }
  // have fall back component, return fall back component
  return <FallbackComponent />;
}

